export type ShopTheme = 'light' | 'dark';

const KEY = 'evi-shop-theme';

/** Read the persisted theme; default dark. */
export function getStoredTheme(): ShopTheme {
  try {
    return localStorage.getItem(KEY) === 'light' ? 'light' : 'dark';
  } catch {
    return 'dark';
  }
}

/** Apply a theme to <html> (data-theme drives the CSS token overrides). */
export function applyTheme(theme: ShopTheme): void {
  document.documentElement.setAttribute('data-theme', theme);
}

/** Persist + apply. */
export function setStoredTheme(theme: ShopTheme): void {
  try {
    localStorage.setItem(KEY, theme);
  } catch {
    // private mode / quota — the applied theme still holds for this session.
  }
  applyTheme(theme);
}
